import _ from 'lodash';
import template from './vrstaRada.html';

class VrstaRadaController {
    constructor(DS) {
        this.datastore = () => {
            return DS;
        };
    }

    $onInit() {
        this.selectedItem = undefined;
    }

    $onChanges(changes) {
        if (changes.items.currentValue.length > 0) {
            this.grupe = [];
            this.refreshState();
        }
    }

    click(item) {
        if (this.selectedItem === item) {
            this.selectedItem = undefined;
            this.onClick({ item: undefined });
        } else {
            this.selectedItem = item;
            this.onClick({ item: item });
        }
    }

    itemSelected(item) {
        // return (!_.isUndefined(this.selectedItem) && this.selectedItem.id === item.id);
        return this.selectedItem === item;
    }

    refreshState() {
        const DS = this.datastore();
        DS.findAll('GrupaRada').then(response => {
            const grupe = response.map(grupa => {
                let clone = _.cloneDeep(grupa);
                let items = _.filter(this.items, { grupa: grupa.id });
                clone.items = [];
                for (var i = 0, j = items.length; i < j; i = i + 3) {
                    clone.items.push(items.splice(0, 3));
                }
                return clone;
            });

            this.grupe = _.filter(grupe, i => {
                return i.items.length > 0;
            });
        });
    }
}

VrstaRadaController.$inject = ['DS'];

const VrstaRadaComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: VrstaRadaController,
    controllerAs: 'vm',
    bindings: {
        items: '<',
        onClick: '&'
    }
};

export { VrstaRadaComponent };
export { VrstaRadaController };



// WEBPACK FOOTER //
// ./app/components/stavkaNaloga/vrstaRada.component.js